import React from "react"
import { MessageStatus } from "../../proto"
import styled, { useTheme } from '~/ui/styled'
import Icon from "~widgets/icon"

const StatusTextDom = styled.Text`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${(props: any) => props.color || "#a2a8af"};
`

const renderMessageStatusAsIcon = ({ status }) => {
const theme = useTheme()
  const size = 8
  switch (status) {
    case MessageStatus.SENDING:
      return <Icon name={"sssj"} size={size} color={theme.colors.secondaryText} />
    case MessageStatus.SENT:
      return <Icon name={"js"} size={size} color={theme.colors.secondaryText} />
    case MessageStatus.DELIVERED:
      return <Icon name={"js"} size={size} color={theme.colors.primary} />
    case MessageStatus.READ:
      return <Icon name={"yidu"} size={size} color={theme.colors.primary} />
    case MessageStatus.FAILED:
      return <Icon name={"close"} size={size} color={theme.colors.danger} />
    default:
      return null
  }
}

interface Props {
  status: MessageStatus
  color?: string
}

const StatusText: React.FC<Props> = ({ status, color }) => {
  return <StatusTextDom color={color}>{renderMessageStatusAsIcon({ status })}</StatusTextDom>
}

export default StatusText
